export default function analytics(event, token) {
  fetch(`${process.env.NEXT_PUBLIC_API_URL}/portal/componentes/analytics?event=${event}&token=${token}`);
}
